import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_105_products: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: { type: "add", screenId: "106" },
    title: "Products",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system  
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
          overflowY: "auto",
          maxHeight: "calc(100vh - 200px)", // Adjust height as needed to enable scrolling within the view

        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "part_no",
            Name: "product_summary",
            style: {
              maxHeight: "calc(100vh - 350px)", // Adjust height to fit view
            },
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/product_add/<id>",
                  Module: "product_add",
                },
                ActionType: "Edit",
                ScreenId: "106",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "product_summary",
                },
                ActionType: "Delete",
                ScreenId: "105",
              },
            ],
            Form: {
              Name: "product_summary",
              TableName: "item_master",
              View: "view_product_details",
              Filter:
                "SELECT id, part_no, item_name, department_id, rack_bin FROM `item_master` WHERE  soft_delete =0 ",

              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Part No.",
                  IsMandatory: true,
                  BindValue: "txt_parts",
                  Json_Attribute: "part_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Item name",
                  IsMandatory: true,
                  BindValue: "txt_itemname",
                  Json_Attribute: "item_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Bin",
                  IsMandatory: true,
                  BindValue: "txt_rackbin",
                  Json_Attribute: "rack_bin",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
